export const trans = (key, parameters = {}, fallback = key) => {
    if (!window.Translator) return fallback;
    const translation = window.Translator.trans(key, parameters);
    return translation === key ? fallback : translation;
};

export const transChoice = (key, choice = 0, parameters = {}, fallback = key) => {
    if (!window.Translator) return fallback;
    const translation = window.Translator.transChoice(key, choice, parameters);
    return translation === key ? fallback : translation;
};

export const transWithFilter = (key, parameters = {}, fallback = key) => {
    if (!window.Translator) return fallback;
    const filteredKey = key.toLowerCase().replaceAll('/', '_').replaceAll(' ', '_').replaceAll(' / ', '_');
    const translation = window.Translator.trans(filteredKey, parameters);
    return (translation === filteredKey || translation === '') ? fallback : translation;
};
